import { get, post, put } from "./api_helper"

// branches
const getListPage = params => get("admin/master/branch/page", params)
const getBettingRateType = () => get("admin/master/branch/betting-rate-type")
const getDetail = id => get(`admin/master/branch/${id}`)
const getListHistoryPage = params =>
  get(`admin/master/other-customer/${params.id}/order-history/page`, params)
const putData = params => put(`admin/master/branch/${params.id}`, params)
const postData = params => post(`admin/master/branch`, params)
const getIgarashiList = () => get(`admin/master/branch/igarashi/list`)
const getList = params => get(`admin/master/branch/list`, params)
const getOtherList = () => get(`admin/master/branch/other/list`)
const getCSVDataApi = (id, params) =>
  get(`admin/master/company/${id}/order-history/csv`, params)

const BranchesAPI = {
  getListPage,
  getBettingRateType,
  getDetail,
  postData,
  putData,
  getIgarashiList,
  getList,
  getOtherList,
  getListHistoryPage,
  getCSVDataApi,
}

export default BranchesAPI
